export class DatabaseClient {
  constructor(private readonly db: SQLitePlugin.Database) {}

  get raw(): SQLitePlugin.Database {
    return this.db;
  }

  close(): void {
    this.db.close();
  }

  executeSql(
    query: string,
    params: unknown[] = []
  ): Promise<SQLitePlugin.Results> {
    return new Promise((resolve, reject) => {
      this.db.executeSql(
        query,
        params,
        (resultSet) => resolve(resultSet),
        (error) => reject(error)
      );
    });
  }

  transaction(
    fn: (tx: SQLitePlugin.Transaction) => void,
    error?: (err: unknown) => void,
    success?: () => void
  ): void {
    this.db.transaction(fn, error, success);
  }

  transactionAsync(fn: (tx: SQLitePlugin.Transaction) => void): Promise<void> {
    return new Promise((resolve, reject) => {
      this.db.transaction(fn, reject, resolve);
    });
  }

  static open(
    onReady?: () => void,
    onError?: () => void
  ): DatabaseClient | undefined {
    if (!window.sqlitePlugin) {
      return undefined;
    }
    const db = window.sqlitePlugin.openDatabase(
      { name: 'driverApp.db', location: 'default' },
      onReady,
      onError
    );
    return new DatabaseClient(db);
  }
}

let activeClient: DatabaseClient | null = null;

export function setDatabaseClient(client: DatabaseClient | null): void {
  activeClient = client;
}

export function getDatabaseClient(): DatabaseClient | null {
  return activeClient;
}
